import { render, staticRenderFns } from "./LabelInputText.vue?vue&type=template&id=53ebbb13&lang=pug&"
import script from "./LabelInputText.vue?vue&type=script&lang=ts&"
export * from "./LabelInputText.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports